/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Card_From_PriceInputs */

const en_card_from_price = /** @type {(inputs: Card_From_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`from ${i?.price} / night`)
};

/**
* | output |
* | --- |
* | "from {price} / night" |
*
* @param {Card_From_PriceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const card_from_price = /** @type {((inputs: Card_From_PriceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Card_From_PriceInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_card_from_price(inputs)
});